import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vShow as _vShow, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "mt-0" }
const _hoisted_2 = { class: "payment-checkout__back-link" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-fw fa-arrow-left d-inline-block me-1" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Zahlungsart ändern ")
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "payment-checkout__gateways-list" }
const _hoisted_9 = { class: "px-4 py-3" }
const _hoisted_10 = ["id", "value"]
const _hoisted_11 = ["src", "srcset"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "payment-checkout__select-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-right" })
], -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-fw fa-exclamation-triangle text-warningX me-1" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Zur Zeit gibt es keine aktive Zahlungsmethode. Bitte kontaktiere deine Gebietsleiterin. ")
const _hoisted_16 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" TBI ")
const _hoisted_18 = {
  key: 1,
  class: "my-5 text-center"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-3x fa-spin fa-spinner" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "mt-3" }, "Zahlungsarten werden geladen ...", -1)
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alert = _resolveComponent("Alert")!
  const _component_WirePayment = _resolveComponent("WirePayment")!
  const _component_PayPalExpressPayment = _resolveComponent("PayPalExpressPayment")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["payment-checkout", {'payment-checkout--selected': !_ctx.unselected}])
  }, [
    _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.unselected ? 'Zahlungsart auswählen' : 'Bezahlen via ' + _ctx.selectedGateway.label), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: "#",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resetSelection && _ctx.resetSelection(...args)), ["prevent"]))
      }, _hoisted_5)
    ]),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _withDirectives(_createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("ul", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activePaymentGateways, (gateway) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: gateway.id
                }, [
                  _createElementVNode("label", _hoisted_9, [
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        id: 'payment-gateway-' + gateway.id,
                        value: gateway.id,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.gatewaySelection) = $event))
                      }, null, 8, _hoisted_10), [
                        [_vModelRadio, _ctx.gatewaySelection]
                      ]),
                      (gateway.id === 2)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.assetsBaseUrl + '/img/paypal/de-btn-expresscheckout/checkout-logo-small-de.png',
                            srcset: `${_ctx.assetsBaseUrl}/img/paypal/de-btn-expresscheckout/checkout-logo-small-de.png 1x, ${_ctx.assetsBaseUrl}/img/paypal/de-btn-expresscheckout/checkout-logo-small-de-2x.png 2x`,
                            alt: "Direkt zu PayPal",
                            title: "Direkt zu PayPal"
                          }, null, 8, _hoisted_11))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(gateway.label), 1)
                          ], 64))
                    ]),
                    _hoisted_12
                  ])
                ]))
              }), 128))
            ], 512), [
              [_vShow, _ctx.activePaymentGateways.length > 0]
            ]),
            (_ctx.activePaymentGateways.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createVNode(_component_Alert, { type: "danger" }, {
                    default: _withCtx(() => [
                      _hoisted_14,
                      _hoisted_15
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ], 512), [
            [_vShow, _ctx.unselected]
          ]),
          (!_ctx.unselected)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                (_ctx.selectedGateway.id === 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_17
                    ], 64))
                  : (_ctx.selectedGateway.id === 1)
                    ? (_openBlock(), _createBlock(_component_WirePayment, {
                        key: 1,
                        product: _ctx.product,
                        "additional-order-data": _ctx.additionalOrderData,
                        onSuccess: _ctx.handleSuccess,
                        gatewayId: _ctx.selectedGateway.id
                      }, null, 8, ["product", "additional-order-data", "onSuccess", "gatewayId"]))
                    : (_ctx.selectedGateway.id === 2)
                      ? (_openBlock(), _createBlock(_component_PayPalExpressPayment, {
                          key: 2,
                          "paypal-client-id": _ctx.selectedGateway.config,
                          product: _ctx.product,
                          "additional-order-data": _ctx.additionalOrderData,
                          onSuccess: _ctx.handleSuccess,
                          gatewayId: _ctx.selectedGateway.id
                        }, null, 8, ["paypal-client-id", "product", "additional-order-data", "onSuccess", "gatewayId"]))
                      : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_21))
  ], 2))
}